import {useIntl} from "react-intl";
import React, {useState} from "react";
import '../scss/SurveySupportNeeds.scss';
import {useCodesData, useCopiedUsersData, useSurveyData, useUserData, useUserSurveyData} from "./SurveyView";
import _ from "lodash"
import {getBranchIconColor, getMessageIcon, Popup, Table, Toast, usePopup} from "../UIElements";
import {findUserById, getNameWithAnnieUser, setBranchCategory, setSupportNeedStatus} from "../DataFunctions";
import {ReactComponent as SupportIcon} from "../svg/support.svg";
import {ReactComponent as ProviderIcon} from "../svg/provider.svg";
import {ReactComponent as BranchesIcon} from "../svg/branches.svg";
import {ReactComponent as CloseIcon} from "../svg/close.svg";
import {useSnackbar} from "../Content";
import {useDataContext} from "./SurveyContextProvider";
import TopicSelector from "../components/TopicSelector/TopicSelector";
import {getTopicDisplayName} from "../utils/topicUtils";

export default function SurveySupportNeeds() {

    return <></>
    /*
    const {userData} = useUserData()
    const {surveyData} = useSurveyData()
    const {codesData} = useCodesData()
    const intl = useIntl()
    let branchesWithSupportNeed = []
    supportNeedCheck(surveyData.config, null, 1, null, null, null)
    function supportNeedCheck(data, parentColor, depth, parent, parentsParent, parentsParentsParent) {
        for (const obj in data) {
            let props = {
                keyValue: obj,
            }
            if (data[obj]?.supportneed === true) {
                if (parentColor) {
                    props[parentColor] = parentColor
                }
                branchesWithSupportNeed.push({
                    "keyValue":obj,
                    "parent": parent,
                    "parentsParent": parentsParent,
                    "parentsParentsParent": parentsParentsParent,
                    "category":data[obj].category,
                    "title":data[obj].message,
                    "condition":data[obj].condition,
                    "color": getBranchIconColor(props, obj.startsWith('branch')),
                    "depth": depth
                    })
            }
            if (typeof data[obj] === 'object' && data[obj] !== null) {
                supportNeedCheck(data[obj], getBranchIconColor(props, true), depth+1, obj, parent, parentsParent)
            }
        }
    }
    let supportNeedCategoryGroups = _.groupBy(branchesWithSupportNeed, need => need.category)

    return <>
        <div className={"support-needs-container"}>
            <h4>
                {intl.formatMessage(
                    {
                        id: 'survey.supportNeeds',
                        defaultMessage: 'Support Needs',
                    })}
            </h4>
            {branchesWithSupportNeed.length > 0 ?
                Object.keys(supportNeedCategoryGroups).map((group, i) => {
                    return <div className={"support-need-group"} key={i}>
                        <SupportNeedRender supportNeedCategoryGroups={supportNeedCategoryGroups} codesData={codesData} group={group} />
                        <SupportProviders userData={userData} group={group} />
                        <SupportBranchGroup supportNeedCategoryGroups={supportNeedCategoryGroups} group={group}/>
                    </div>
                })
            :
                <p className={"placeholder"}>
                    {intl.formatMessage(
                        {
                            id: 'survey.supportNeeds.placeholder',
                            defaultMessage: 'Your messages don\'t create any support needs currently. Start by activating a lifesaver in the message tab.',
                        })}
                </p>
            }
            <div>
            </div>
        </div>
        <SurveyCoordinators />
        </>

     */
}

export function SurveyCoordinators() {
    const intl = useIntl()
    const { value: surveyData } = useDataContext('surveyData')
    const { value: userSurveyData, setValue: setUserSurveyData } = useDataContext('userSurveyData')
    const { value: userData } = useDataContext('userData')
    const surveyCoordinators = userSurveyData.filter(user => user.meta.coordinator)
    const [searchText, setSearchText] = useState("")
    const filterUserData = userData.filter(isIdOrName)
    const { showPopup } = usePopup()

    function isIdOrName(user) {
        if (user.hasOwnProperty("id") && user.id.toLowerCase().includes(searchText.toLowerCase())){
            return true
        }
        if (user.hasOwnProperty("meta") && user.meta) {
            if (user.meta.hasOwnProperty("firstname")) {
                if (user.meta.firstname.toLowerCase().includes(searchText.toLowerCase())) {
                    return true
                }
            }
            if (user.meta.hasOwnProperty("lastname")) {
                if (user.meta.lastname.toLowerCase().includes(searchText.toLowerCase())) {
                    return true
                }
            }
        }
        return false
    }

    const setCoordinatorToSurvey = (user) => {
        const newUserSurveyData = [...userSurveyData]
        if (newUserSurveyData.some(obj => obj.annieuser === user.id)) {
            const userIndex = newUserSurveyData.findIndex(obj => obj.annieuser === user.id)
            newUserSurveyData[userIndex].meta.coordinator = true
        } else {
            newUserSurveyData.push({
                annieuser:user.id,
                survey:surveyData.id,
                meta:{
                    coordinator: true
                }
            })
        }
        setUserSurveyData(newUserSurveyData)
    }

    const removeCoordinatorFromSurvey = (coordinator) => {
        const newUserSurveyData = [...userSurveyData]
        const userIndex = newUserSurveyData.findIndex(obj => obj.annieuser === coordinator.annieuser)
        delete newUserSurveyData[userIndex].meta.coordinator
        setUserSurveyData(newUserSurveyData)
    }

    return <>
        <h4>
            {intl.formatMessage(
                {
                    id: 'survey.supportNeeds.coordinators',
                    defaultMessage: 'Survey Coordinators',
                })}
        </h4>
        <div className={"block-container survey-coordinators"}>
            {surveyCoordinators.length < 1 &&
            <p className={"placeholder"}>
                {intl.formatMessage(
                    {
                        id: 'survey.surveyCoordinator.placeholder',
                        defaultMessage: 'Your survey doesn\'t have a coordinator. The coordinator can see all support needs generated by this survey.',
                    })}
            </p>}
            {surveyCoordinators.map((user, i) => {
                return <div className={"block"} key={i}>
                    <span>{getNameWithAnnieUser(userData, user.annieuser)}</span>
                    <div className={"close-icon"} onClick={() => removeCoordinatorFromSurvey(user)}>
                        <CloseIcon/>
                    </div>
                </div>
            })}
        </div>
        <button className={"add-new-button"} onClick={() => {showPopup(<CoordinatorPicker />, 'max-width')}}>
            {intl.formatMessage(
                {
                    id: 'survey.supportNeeds.addCoordinator',
                    defaultMessage: '+ Add Coordinator',
                })}
        </button>
    </>
}

function CoordinatorPicker() {
    const intl = useIntl()
    const { value: surveyData } = useDataContext('surveyData')
    const { value: userData } = useDataContext('userData')
    const { value: userSurveyData, setValue: setUserSurveyData } = useDataContext('userSurveyData')
    const coordinators = userSurveyData.filter(obj => obj.hasOwnProperty('meta') && obj.meta.hasOwnProperty('coordinator') && obj?.meta?.coordinator)
    const initialSelections = coordinators?.length > 0 ? coordinators.map(user => user?.annieuser) : []
    const [selectedProviders, setSelectedProviders] = useState(initialSelections)
    const {hidePopup} = usePopup()

    const columns = React.useMemo(()=>[
        {
            Header: () => (
                <span>
                    {intl.formatMessage({
                        defaultMessage:'Email',
                        id:'email'
                    })}
                    <i> {intl.formatMessage({
                        defaultMessage:'or id',
                        id:'orId'
                    })}</i>
                </span>
            ),
            accessor: 'meta.email',
            Cell: ({ cell: { value }, row: { original } }) => {
                if (value) {
                    return value
                } else {
                    return <i>{original?.meta?.userid || original?.id}</i>
                }
            },
        },
        {
            Header: intl.formatMessage({defaultMessage:'Name',id:'name'}),
            id: 'name',
            accessor: row => `${row.meta.firstname || ''} ${row.meta.lastname || ''}`.trim(),
        },
        {
            Header: intl.formatMessage({defaultMessage:'Role',id:'role'}),
            accessor: 'meta.role',
        },
        {
            Header: intl.formatMessage({defaultMessage:'Aliases',id:'aliases'}),
            accessor: 'meta.aliases',
            Cell: ({value}) => {
                if (value === null || value === undefined) {
                    return ''
                }

                return value.map((user, i) => (
                    <React.Fragment key={i}>
                        {user}{i < value.length - 1 ? ', ' : ''}
                        {i < value.length - 1 && <br />}
                    </React.Fragment>
                ))
            }
        },
    ],[])
    const globalSearchPlaceholder = intl.formatMessage({id:'searchSupportProviders.placeholder', defaultMessage:'Search support providers'})

    const removeUserSelection = (user) => {
        setSelectedProviders((prevState) => prevState.filter((provider) => provider !== user))
    }

    const addUserSelection = (user) => {
        setSelectedProviders((prevState) => [...prevState, user])
    }

    const handleProviderUpdate = (id, state) => {
        if (!state) {
            removeUserSelection(id)
        } else {
            addUserSelection(id)
        }
    }

    const clearSelections = () => {
        setSelectedProviders([])
    }

    const cancelProviderEdits = () => {
        hidePopup()
    }

    const confirmProviderEdits = () => {
        const selectionSet = new Set(selectedProviders)
        const userMap = new Map(userSurveyData.map(user => [user.annieuser, user]))

        for (let user of selectionSet) {
            if (userMap.has(user)) {
                userMap.get(user).meta.coordinator = true
            } else {
                userMap.set(user, {
                    annieuser: user,
                    survey: surveyData?.id,
                    meta: {
                        coordinator: true,
                    }
                })
            }
        }

        // Remove category from users that are not in selection
        for (let userObj of userMap.values()) {
            if (!selectionSet.has(userObj.annieuser) && userObj?.meta?.coordinator) {
                delete userObj.meta.coordinator
            }
        }

        const newUserSurveyData = Array.from(userMap.values())

        setUserSurveyData(newUserSurveyData)

        hidePopup()
    }

    return <div className={"provider-selection"}>
        <h1>
            {intl.formatMessage({
                id: 'survey.supportNeeds.addCoordinatorToSurvey',
                defaultMessage: 'Add a Coordinator to this Survey',
            })}
        </h1>
        <div className={"selected-providers"}>
            <h3>{intl.formatMessage({id:'selectedCoordinators', defaultMessage: 'Selected coordinators'})} ({selectedProviders?.length})
            <div className={"provider-options"}>
                {selectedProviders?.length > 0 ?
                    <button className={"text"} onClick={()=> clearSelections()}>
                        {intl.formatMessage(
                            {
                                id: 'clear',
                                defaultMessage: 'Clear',
                            })}
                    </button> :
                    <button className={"text"} disabled>
                        {intl.formatMessage(
                            {
                                id: 'clear',
                                defaultMessage: 'Clear',
                            })}
                    </button>
                }
            </div>
            </h3>
            <div className={"selected-providers-container"}>
                {selectedProviders.map((user, i)=>{
                    return <div className={"provider"} key={i}>
                        {findUserById(user, userData)}
                        <button onClick={()=> removeUserSelection(user)}>
                            <CloseIcon/>
                        </button>
                    </div>
                })}
                {selectedProviders?.length < 1 &&
                    <p className={"placeholder"}>{intl.formatMessage({defaultMessage:'No coordinators providers set.', id:'noCoordinatorsSet'})}</p>
                }
            </div>
        </div>
        <Table columns={columns}
               data={userData}
               globalSearchPlaceholder={globalSearchPlaceholder}
               initialSelections={selectedProviders}
               updateSelectedProviders={(id, state)=>handleProviderUpdate(id, state)} />
        <div className={"modal-options"}>
            <div>
                <button className={"cancel"} onClick={()=> cancelProviderEdits()}>
                    {intl.formatMessage(
                        {
                            id: 'modal.cancel',
                            defaultMessage: 'Cancel',
                        })}
                </button>
                <button onClick={()=> confirmProviderEdits()} className={"confirm"}>
                    {intl.formatMessage(
                        {
                            id: 'select',
                            defaultMessage: 'Select',
                        })}
                </button>
            </div>
        </div>
    </div>
}

/*
function Old() {
    const intl = useItl()
    return <Popup>
            <h1>
                {intl.formatMessage({
                    id: 'survey.supportNeeds.addCoordinatorToSurvey',
                    defaultMessage: 'Add a Coordinator to this Survey',
                })}
            </h1>
            <p>
                {intl.formatMessage({
                    id: 'main.sidebar.supportProviders',
                    defaultMessage: 'Support Providers',
                })}
            </p>
            <input type={"text"} className={"search"} value={searchText}
                   onChange={e => {
                       setSearchText(e.target.value)
                   }}
                   placeholder={intl.formatMessage(
                       {
                           id: 'supportProviders.search.placeholder',
                           defaultMessage: 'Search for Support Providers',
                       })}/>
            <div className={"block-container"}>
                {
                    filterUserData.map((user, i) => {
                        const userIndex = userSurveyData.some(obj => obj.annieuser === user.id) && userSurveyData.findIndex(obj => obj.annieuser === user.id)
                        if ((userIndex || userIndex === 0) && userSurveyData[userIndex].meta.coordinator) {
                            return <div className={"block selected"} key={i}
                            >
                                {
                                    user.meta && user.meta.firstname && user.meta.lastname ?
                                        user.meta.firstname + " " + user.meta.lastname :
                                        user.id
                                }
                            </div>
                        }
                        return <div className={"block outlined"} key={i} onClick={() => {
                            setCoordinatorToSurvey(user)
                        }}>
                            {
                                user.meta && user.meta.firstname && user.meta.lastname ?
                                    user.meta.firstname + " " + user.meta.lastname :
                                    user.id
                            }
                        </div>
                    })
                }
                {filterUserData.length < 1 &&
                    <p className={"placeholder"}>
                        {intl.formatMessage(
                            {
                                id: 'supportProviders.nonFound.placeholder',
                                defaultMessage: 'Sorry! No support providers found.',
                            })}
                    </p>
                }
            </div>
        </Popup>
}


 */
function SupportBranchGroup({supportNeedCategoryGroups, group}) {
    const intl = useIntl()
    return <>
        <div className={"support-container"}>
            <div className={"icon"} title={intl.formatMessage(
                {
                    id: 'survey.supportNeeds.branch',
                    defaultMessage: 'Branches with Support Need',
                })}>
                <BranchesIcon/>
            </div>
            <div className={"needs-container"}>
                {supportNeedCategoryGroups[group].map((need, i) => {
                    return <SupportBranch need={need} key={i}/>
                })}
            </div>
        </div>
    </>
}

function SupportBranch({need}) {
    let isBranch = need.keyValue.startsWith('branch')

    return <>
        <div className={"message-icon"} title={need.title} style={{backgroundColor:need.color}}>
            {getMessageIcon(need, isBranch)}
        </div>
        </>
}

function SupportNeedRender({supportNeedCategoryGroups, codesData, group}) {
    const intl = useIntl()
    const [showPopup, setShowPopup] = useState(false)

    return <>
        <div className={"support-container"}>
            <div className={"icon"} title={intl.formatMessage(
                {
                    id: 'survey.supportTopic',
                    defaultMessage: 'Support Topic',
                })}>
                <SupportIcon/>
            </div>
        {codesData.hasOwnProperty(group) ?
            <div className={"block"} onClick={() => setShowPopup(true)}>
                {codesData[group]["title"]}
            </div> :
            <div className={"block not-assigned"} onClick={() => setShowPopup(true)}>
                {intl.formatMessage({
                    id: 'survey.chooseSupportNeed',
                    defaultMessage: '+ Choose Support Topic',
                })}
            </div>
        }
    </div>
        {showPopup &&
        <Popup closePopup={() => setShowPopup(false)}>
            <SupportNeedSelector group={group} isGroup={true} supportNeedCategoryGroups={supportNeedCategoryGroups} closePopup={() => setShowPopup(false)}/>
        </Popup>
        }
    </>
}

export function SupportNeedSelector({need, group, isGroup, closePopup, supportNeedCategoryGroups, hideRemoveSupportNeed}) {
    const { value: surveyData, setValue: setSurveyData } = useDataContext('surveyData')
    const { value: categoryData, setValue: setCategoryData } = useDataContext('categoryData')

    const intl = useIntl()

    const removeSupportNeed = () => {
        const newSurveyData = {...surveyData}
        setSupportNeedStatus(true, newSurveyData.config, need.depth, need.keyValue, need.parent, need.parentsParent, need.parentsParentsParent)
        setSurveyData(newSurveyData)
        closePopup()
    }

    const setSupportCategory = category => {
        const newSurveyData = {...surveyData}
        setBranchCategory(newSurveyData.config, need.depth, category, need.keyValue, need.parent, need.parentsParent, need.parentsParentsParent)
        setSurveyData(newSurveyData)
        closePopup()
    }

    const setSupportCategoryToGroup = (category, group) => {
        const newSurveyData = {...surveyData}
        supportNeedCategoryGroups[group].forEach(need => {
            setBranchCategory(newSurveyData.config, need.depth, category, need.keyValue, need.parent, need.parentsParent, need.parentsParentsParent)
        })
        setSurveyData(newSurveyData)
        closePopup()
    }

    const onSelect = (code, codeData) => {
        if (!categoryData[code]) {
            setCategoryData({ ...categoryData, [code]: codeData });
        }
        if (isGroup) {
            setSupportCategoryToGroup(code, group)
        } else {
            setSupportCategory(code)
        }
    }

    const currentCategory = isGroup ? null : need?.data?.[need.keyValue]?.category;

    const title = isGroup
        ? <>
            {supportNeedCategoryGroups[group].length > 1
                ? intl.formatMessage({ id: 'survey.assignNeedForAnswers', defaultMessage: 'Choose Support Topic for Answers' })
                : intl.formatMessage({ id: 'survey.assignNeedForAnswer', defaultMessage: 'Choose Support Topic for Answer' })
            }
            {supportNeedCategoryGroups[group].map((need, i) => {
                if (i === 0) return <b key={i}> {need.keyValue.slice(6)}</b>
                if (i + 1 === supportNeedCategoryGroups[group].length)
                    return <React.Fragment key={i}> & <b>{need.keyValue.slice(6)}</b></React.Fragment>
                return <React.Fragment key={i}>, <b>{need.keyValue.slice(6)}</b></React.Fragment>
            })}
        </>
        : <>
            {intl.formatMessage({ id: 'survey.assignNeedForAnswer', defaultMessage: 'Choose Support Topic for Answer' })}
            <b> {need.keyValue.slice(6)}</b>
        </>

    return <>
        <TopicSelector
            categoryData={categoryData}
            selectedTopics={currentCategory ? [currentCategory] : []}
            onSelect={onSelect}
            title={title}
        />
        {!isGroup && !hideRemoveSupportNeed &&
        <div className={"remove-element"}>
            <p>
                <span className={"red"} onClick={() => removeSupportNeed()}>{intl.formatMessage({
                    id: 'survey.remove',
                    defaultMessage: 'Remove',
                })}</span>
                {intl.formatMessage({
                    id: 'survey.remove.supportNeed',
                    defaultMessage: ' Support Need from Answer',
                })} {need.keyValue.slice(6)}
            </p>
        </div>
        }
    </>
}

function SupportProviders({userData, group}) {
    const {userSurveyData, setUserSurveyData} = useUserSurveyData()
    const intl = useIntl()
    const [showPopup, setShowPopup] = useState(false)

    const removeProviderFromSurvey = user => {
        const newUserSurveyData = [...userSurveyData]
        const userIndex = newUserSurveyData.findIndex(obj => obj.annieuser === user.annieuser)
        delete newUserSurveyData[userIndex].meta.category[group]
        setUserSurveyData(newUserSurveyData)
    }

    return <>
        <div className={"support-container"}>
            <div className={"icon"} title={intl.formatMessage(
                {
                    id: 'survey.supportNeeds.supportProvider',
                    defaultMessage: 'Support Provider',
                })}>
                <ProviderIcon/>
            </div>
            <div className={"support-providers-container"}>
                {userSurveyData.map((user, i) => {
                    if (user.meta && user.meta.hasOwnProperty("category") && user.meta.category.hasOwnProperty(group)) {
                        return <div className={"support-provider block"} key={i}>
                            <span>{getNameWithAnnieUser(userData, user.annieuser)}</span>
                            <div className={"close-icon"} onClick={() => removeProviderFromSurvey(user)}>
                                <CloseIcon/>
                            </div>
                        </div>
                    }
                    return false
                })}
                {group ?
                <button className="support-provider block not-assigned add-provider" onClick={() => {
                    setShowPopup(true)
                }}>
                    {userSurveyData.filter(user => user.meta && user.meta.hasOwnProperty("category") && user.meta.category.hasOwnProperty(group)).length < 1 ?
                        intl.formatMessage(
                        {
                            id: 'survey.supportNeeds.addSupportProvider',
                            defaultMessage: '+ Add Support Provider',
                        }) :
                        intl.formatMessage(
                            {
                                id: 'survey.supportNeeds.editSupportProviders',
                                defaultMessage: 'Edit Support Providers',
                            })
                    }
                </button> :
                    <p className={"placeholder"}>
                        {intl.formatMessage(
                            {
                                id: 'survey.supportNeeds.addSupportProvider.placeholder',
                                defaultMessage: 'Add support topic before providers',
                            })}
                    </p>
                }
            </div>
        </div>
        {showPopup &&
        <Popup closePopup={() => setShowPopup(false)}>
            <SupportProviderSelector group={group} hidePopup={()=>setShowPopup(false)}/>
        </Popup>
        }
    </>
}

export function SupportProviderSelector({group, hidePopup}){
    const intl = useIntl()
    const { value: surveyData } = useDataContext('surveyData')
    const { value: userSurveyData, setValue: setUserSurveyData } = useDataContext('userSurveyData')
    const { value: userData, setValue: setUserData } = useDataContext('userData')
    const { value: categoryData, setValue: setCategoryData } = useDataContext('categoryData')
    const { value: copiedUsersData, setValue: setCopiedUsersData } = useDataContext('copiedUsersData')

    const [tempUserSurveyData, setTempUserSurveyData] = useState(userSurveyData)
    const [searchText, setSearchText] = useState("")
    let filterUserData = userData.filter(isIdOrName)

    const {setSnackbarData} = useSnackbar()

    function isIdOrName(user) {
        if (user.hasOwnProperty("id") && user.id.toLowerCase().includes(searchText.toLowerCase())){
            return true
        }
        if (user.hasOwnProperty("meta") && user.meta) {
            if (user.meta.hasOwnProperty("firstname")) {
                if (user.meta.firstname.toLowerCase().includes(searchText.toLowerCase())) {
                    return true
                }
            }
            if (user.meta.hasOwnProperty("lastname")) {
                if (user.meta.lastname.toLowerCase().includes(searchText.toLowerCase())) {
                    return true
                }
            }
        }
        return false
    }

    const setSupportProviderToCategory = user => {
        const newUserSurveyData = [...tempUserSurveyData]
        if (newUserSurveyData.some(obj => obj.annieuser === user.id)) {
            const userIndex = newUserSurveyData.findIndex(obj => obj.annieuser === user.id)
            if (newUserSurveyData[userIndex].meta.hasOwnProperty("category")) {
                newUserSurveyData[userIndex].meta.category[group] = true
            } else {
                newUserSurveyData[userIndex].meta = {
                    coordinator: true,
                    category: {
                        [group]:true
                    }
                }
            }
        } else {
            newUserSurveyData.push({
                annieuser:user.id,
                survey:surveyData.id,
                meta:{
                    category:{
                        [group]:true
                    }
                }
            })
        }
        setTempUserSurveyData(newUserSurveyData)
    }

    const removeSupportProviderFromTemp = user => {
        const newUserSurveyData = [...tempUserSurveyData]
        const userIndex = newUserSurveyData.findIndex(obj => obj.annieuser === user.id)
        delete newUserSurveyData[userIndex].meta.category[group]
        setTempUserSurveyData(newUserSurveyData)
    }

    const cancelProviderEdits = () => {
        setTempUserSurveyData([])
        hidePopup()
    }

    const confirmProviderEdits = () => {
        setUserSurveyData([...tempUserSurveyData])
        setTempUserSurveyData([])
        hidePopup()
    }

    const setUsersToCopy = () => {
        const copyUsers = tempUserSurveyData.filter(user => user.meta && user.meta.category &&user.meta.category[group])
        setCopiedUsersData(copyUsers)
        setSnackbarData({
            show: true,
            text: intl.formatMessage(
                {
                    id: 'survey.supportProvider.providersCopied',
                    defaultMessage: 'Support Providers Copied!',
                }),
            state: "info",
            autoHide: true,
        })
    }

    const pasteUsersToSupportNeed = () => {
        const newUserSurveyData = [...tempUserSurveyData]
        copiedUsersData.forEach(user => {
            if (newUserSurveyData.some(obj => obj.annieuser === user.annieuser)) {
                const userIndex = newUserSurveyData.findIndex(obj => obj.annieuser === user.annieuser)
                if (newUserSurveyData[userIndex].meta.hasOwnProperty("category")) {
                    newUserSurveyData[userIndex].meta.category[group] = true
                } else {
                    newUserSurveyData[userIndex].meta = {
                        coordinator: true,
                        category: {
                            [group]:true
                        }
                    }
                }
            } else {
                newUserSurveyData.push({
                    annieuser:user.annieuser,
                    survey:surveyData.id,
                    meta:{
                        category:{
                            [group]:true
                        }
                    }
                })
            }
        })
        setTempUserSurveyData(newUserSurveyData)
        setSnackbarData({
            show: true,
            text: intl.formatMessage(
                {
                    id: 'survey.supportProvider.providersPasted',
                    defaultMessage: 'Support Providers Pasted!',
                }),
            state: "info",
            autoHide: true,
        })
    }

    const clearUsersFromSupportNeed = () => {
        const newUserSurveyData = [...tempUserSurveyData]
        for (let i = 0; i < newUserSurveyData.length; i++) {
            const user = newUserSurveyData[i]
            if (user.hasOwnProperty("meta") && user.meta.hasOwnProperty("category") && user.meta.category.hasOwnProperty(group) && user.meta.category[group] ) {
                delete newUserSurveyData[i].meta.category[group]
            }
        }
        setTempUserSurveyData(newUserSurveyData)
    }

    return <>
        <h1>
            {intl.formatMessage({
                id: 'survey.selectSupportProvidersForSupportNeed',
                defaultMessage: 'Select Support Providers for Support Need',
            })}
            <b> {categoryData[group] ? getTopicDisplayName(group, categoryData[group], intl) : group}</b>
        </h1>
        <p>
            {intl.formatMessage({
                id: 'main.sidebar.supportProviders',
                defaultMessage: 'Support Providers',
            })}
        </p>
        <input type={"text"} className={"search"} value={searchText}
               onChange={e => {
                   setSearchText(e.target.value)
               }}
               placeholder={intl.formatMessage(
                   {
                       id: 'supportProviders.search.placeholder',
                       defaultMessage: 'Search for Support Provider',
                   })}/>
        <div className={"block-container"}>
            {
                filterUserData.map((user, i) => {
                    const userIndex = tempUserSurveyData.some(obj => obj.annieuser === user.id) && tempUserSurveyData.findIndex(obj => obj.annieuser === user.id)
                    if ((userIndex || userIndex === 0) && tempUserSurveyData[userIndex].meta.hasOwnProperty("category") && tempUserSurveyData[userIndex].meta.category[group]) {
                        return <div className={"block outlined support-provider selected"} key={i}
                                    onClick={() => removeSupportProviderFromTemp(user)}>
                            {
                                user.meta && user.meta.firstname && user.meta.lastname ?
                                    user.meta.firstname + " " + user.meta.lastname :
                                    user.id
                            }
                        </div>
                    }
                    return <div className={"block outlined"} key={i}
                                onClick={() => setSupportProviderToCategory(user)}>
                        {
                            user.meta && user.meta.firstname && user.meta.lastname ?
                                user.meta.firstname + " " + user.meta.lastname :
                                user.id
                        }
                    </div>
                })
            }
            {filterUserData.length < 1 &&
            <p className={"placeholder"}>
                {intl.formatMessage(
                    {
                        id: 'supportProviders.nonFound.placeholder',
                        defaultMessage: 'Sorry! No support providers found.',
                    })}
            </p>
            }
        </div>
        <div className={"modal-options"}>
            <button className={"text"} onClick={()=>setUsersToCopy()}>
                {intl.formatMessage(
                    {
                        id: 'copy',
                        defaultMessage: 'Copy',
                    })}
            </button>
            {copiedUsersData.length > 0 &&
            <button className={"text"} onClick={()=>pasteUsersToSupportNeed()}>
                {intl.formatMessage(
                    {
                        id: 'paste',
                        defaultMessage: 'Paste',
                    })}
            </button>
            }
            <button className={"text alert"} onClick={()=>clearUsersFromSupportNeed()}>
                {intl.formatMessage(
                    {
                        id: 'clear',
                        defaultMessage: 'Clear',
                    })}
            </button>
            <button className={"cancel"} onClick={()=>cancelProviderEdits()}>
                {intl.formatMessage(
                    {
                        id: 'modal.cancel',
                        defaultMessage: 'Cancel',
                    })}
            </button>
            <button onClick={()=>confirmProviderEdits()} className={"confirm"}>
                {intl.formatMessage(
                    {
                        id: 'select',
                        defaultMessage: 'Select',
                    })}
            </button>
        </div>
    </>
}